<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disable" :model="formParameter" :inline="true" label-width="80px"
        :rules="rules">
      
        <el-row>
          <el-col :span="8">
            <el-form-item label="招生学年" prop="zsyear">
              <el-input v-model="formParameter.zsyear" autocomplete="off" :disabled="disabled"></el-input>

            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="层次" prop="level">
              
              <select-option-dictionary placeholder="请选择" :popper-append-to-body="false" v-model="formParameter.level"
                dkey="xli-level" @change="typeChange1"></select-option-dictionary>

            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="报读院校" prop="skname" :inline="true">
                <el-input v-model="formParameter.skname" @change="typeChange3" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="学校代码" prop="code"><el-input v-model="formParameter.code" autocomplete="off">{{
              formParameter.code }}</el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="开始时间" prop="starttm">
              <el-date-picker v-model="formParameter.starttm" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="结束时间" prop="endtm">
              <el-date-picker v-model="formParameter.endtm" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="报考条件" prop="condi">
              <el-input type="textarea" v-model="formParameter.condi" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="报名材料" prop="bmcl"><el-input type="textarea" v-model="formParameter.bmcl"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上课地点" prop="ckdd"><el-input type="textarea" v-model="formParameter.ckdd"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="其他费用" prop="remarks">
              <el-input type="textarea" v-model="formParameter.remarks" autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div slot="footer">
      <el-button v-if="!disable" type="primary" v-has-permission-code-and="'003000000005'" :loading="confirmLoading"
        @click="confirm()">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import api from "@/api/xueli/xlschool.js";
import popup from "@/components/popup/drawerPopup.vue";
import imageUpload from '@/components/biz/imageUpload/imageUpload.vue';
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import xlschool from '@/api/xueli/xlschool.js';
export default {
  name: "edit",
  components: {
    popup,
    selectOptionDictionary,
    imageUpload,

  },
  data() {
    return {
      disable: false,
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      zsyearList: [], //招生学年去重列表
      levelName: [],  //层次去名称列表
      sknameList: [],  //招生专业去重列表
      codeList: '',//招生专业去重列表
      schoolName: [], //学校名称去重名称列表
      response: [],   //xlschool表的数据
      transition: '', //选择学年或层次后的数据 过渡
      transitLevel: '', //选择层次或层次后的数据 过渡
      transitSkname: '', //选择层次或层次后的数据 过渡
      staging: [],       //暂存
      searchParams: '',
      listData: "",
      listLoading: '',
      nations: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ],//民族
      rules: {
        //招生学年
        zsyear: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 20,
            trigger: "blur",
          },
        ],

        //学校名称
        skname: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    change(val) {
    },
    //学校名称选中后限制层次输出
    typeChange(e) {
      console.log(e);
      if (this.formParameter.zsyear != undefined) {
        this.transition = this.response.filter(item => {
          return item.zsyear == e
        })
        console.log('typeChange', this.transition);
        this.levelName = []
        this.formParameter.level = ''
        this.formParameter.subjects = ''
        // this.formParameter.skname = ''
        for (let i = 0; i < this.transition.length; i++) {
          this.levelName.push(this.transition[i].level);
        }
        this.levelName = [...new Set(this.levelName)]
      }
    },
    typeChange1(e) {
      console.log(e);
      if (this.formParameter.level) {
        this.transitLevel = this.transition.filter(item => {
          return item.level == e
        })
        // console.log('typeChange1', this.transitLevel);
        this.sknameList = []
        for (let i = 0; i < this.transitLevel.length; i++) {
          if (this.transitLevel[i].children) {
            for (let j = 0; j < this.transitLevel[i].children.length; j++) {
              this.sknameList.push(this.transitLevel[i].children[j].nm);
            }
          }
        }
        this.sknameList = [...new Set(this.sknameList)]
      }
    },
    typeChange2(e) {
      // console.log(e);
      if (this.formParameter.subjects) {
        this.transitSkname = this.transitLevel.filter(item => {
          if (item.children) {
            // this.staging = item.children.filter(v => {
            // 	if (v.nm == e) {
            // 		return v
            // 	}
            // })
            this.schoolName = []
            for (let i = 0; i < item.children.length; i++) {
              if (item.children[i].nm == e) {
                return item
              }
            }
            // for (let i = 0; i < item.children.length; i++) {
            // 	console.log('item.children.includes(this.staging)', item.children[i].nm.includes(this.staging.nm));
            // 	return item.children[i].nm.includes(this.staging.nm)
            // }
            // console.log('111111', this.staging);
            // console.log('515412', (item.children.includes(this.staging)));
            // return (item.children.includes(this.staging));
          }
        })
        for (let i = 0; i < this.transitSkname.length; i++) {
          this.schoolName.push(this.transitSkname[i].skname);
          // this.formParameter.skname = ''
        }
        this.schoolName = [...new Set(this.schoolName)]
      }
    },
    typeChange3(e) {
      console.log(e);
      if (this.formParameter.skname) {
        // console.log('this.transitLevel', this.transitLevel);
        this.codeList = this.transitSkname.filter(item => {
          // console.log('item', item);
          return (item.skname == e)
        })
        let code = []
        for (let i = 0; i < this.codeList.length; i++) {
          code.push(this.codeList[i].code);
        }
        console.log('this.codeList.code', code);
        this.formParameter.code = code[0]
      }
    },
    //获取数据
    list() {
      // xlschool.list({}, (response) => {
      //   this.response = response.data.records
      //   console.log("response", this.response);
      //   for (let i = 0; i < this.response.length; i++) {
      //     // this.schoolName.push(this.response[i].skname);
      //     // this.levelName.push(this.response[i].level);
      //     this.zsyearList.push(this.response[i].zsyear);
      //   }
      //   // this.schoolName = [...new Set(this.schoolName)]  //学校名称去重列表
      //   // this.levelName = [...new Set(this.levelName)]    //层次去重列表
      //   this.zsyearList = [...new Set(this.zsyearList)]  //招生学年去重列表
      //   this.listLoading = false;

      // });
      let params = this.$utils.merger(this.searchParams);
      api.cascadeSub(params, response => {
        // 通过vue的双向绑定渲染数据
        console.log("response", response, 151);
        this.listData = response.data;
        // this.listData.records.forEach(rcd => {
        //   if (rcd.subjects) {
        //     rcd.subjects = JSON.parse(rcd.subjects)
        //   }
        // });
      })
    },
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      // console.log('parameter', parameter);
      this.disable = disabled;
      this.disabled = false;

      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });

    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.disable = false;
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        if (!this.parameter.id) {
          //添加
          let parameter = this.$utils.merger(this.formParameter);
          api.save(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          let parameter = this.$utils.merger(this.formParameter);
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );

        }
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        this.disabled = true;
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;
          this.popupLoading = false;
        });
        this.list()
      } else {
        //添加
        this.popupLoading = false;
        this.list()
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
